<div class="toolbar-wrapper d-flex justify-content-between align-items-center">
  <div class="logo">
    <a style="cursor: pointer" (click)="this.goHome()">
      <img src="../../../../assets/images/logo-sdw.svg" alt="" />
    </a>
    <!--<a href="/">
    <img src="../../../../assets/images/logo.new.png" alt="">
  </a>-->
  </div>

  <!-- ++ -->
  <app-order-search class="d-block ms-3 ms-3"></app-order-search>

  <div class="profile d-flex">
    <!-- <a href="" class="mdi mdi-account mdi-36px"></a> -->
    <div class="d-flex toolbar-actions">
      <div class="d-flex toolbar-nav">
        <!--
      <div class="toolbar-nav-button-wrap">
        <dx-button [elementAttr]="{ title: 'SEARCH_ISSUE' | translate }" class="toolbar-nav-button">
          <i class="dx-icon mdi mdi-magnify"></i>
        </dx-button>
      </div>
      -->
        <div id="info-panel-step-1" class="toolbar-nav-button-wrap">
          <dx-button [elementAttr]="{ title: 'NOTIFICATIONS' | translate }" (onClick)="showNotificationMenu()" class="toolbar-nav-button">
            <i class="dx-icon mdi mdi-bell-ring"></i>

            @if (bellOrdersIsLoading) {
              <ng-container *ngTemplateOutlet="loading"></ng-container>
            } @else {
              <span class="dx-button-text">
                <span class="total-count">{{ (bellOrders$ | async)?.estimate?.length }}</span>
              </span>
            }
          </dx-button>

          @if (isShowNotificationMenu) {
            <div class="toolbar-dropdown">
              <app-notifications [bellOrders]="bellOrders$ | async" (onClose)="showNotificationMenu()"></app-notifications>
            </div>
          }
        </div>

        <div id="info-panel-step-2" class="toolbar-nav-button-wrap">
          <!-- <dx-button (onClick)="this.goToOrdersPage()" [elementAttr]="{ title: 'TITLE_ORDERS_PAGE' | translate }" class="toolbar-nav-button">
        <i class="dx-icon mdi mdi-clipboard-list"></i>
        <span class="dx-button-text">
          <span class="total-count">{{(this.orders$ | async)?.length}}</span>
        </span>
      </dx-button> -->
          <dx-button (onClick)="this.goToIssuesPage()" [elementAttr]="{ title: 'ORDERS' | translate }" class="toolbar-nav-button">
            <i class="dx-icon mdi mdi-clipboard-list"></i>

            @if (orders$ | async; as orders) {
              <span class="dx-button-text">
                <span class="total-count">{{ orders.length }}</span>
              </span>
            } @else {
              <ng-container *ngTemplateOutlet="loading"></ng-container>
            }
          </dx-button>
        </div>
        <div id="info-panel-step-3" class="toolbar-nav-button-wrap">
          <dx-button (onClick)="this.createIssue()" [elementAttr]="{ title: 'CREATE_ORDER' | translate }" class="toolbar-nav-button">
            <i class="dx-icon mdi mdi-note-plus"></i>
          </dx-button>
        </div>
        <!-- <div class="toolbar-nav-button-wrap">
    <dx-button [disabled]="this.isDisabledInfo" (onClick)="this.showMasterHelp()" [elementAttr]="{ title: 'TRAINING' | translate }" class="toolbar-nav-button">
      <i class="dx-icon mdi mdi-school"></i>
    </dx-button>
  </div> -->
      </div>
    </div>
    @if (!this.user) {
      <div>{{ 'TOOLBAR_NOT_AUTHORIZED' | translate }}</div>
    }
    <div class="toolbar-avatar">
      <a href="javascript:void(0)" class="toolbar-avatar-link">
        <!--<img *ngIf="this.user?.photo" [src]="this.sanitizer.bypassSecurityTrustResourceUrl('data:image/png;base64,' + this.user.photo)" style="border-radius: 25px; width: 35px; height: 35px; object-fit: cover;" />
    <img *ngIf="!this.user?.photo" src="../../../../assets/images/nouser.png" alt="">-->
        @if (this.user?.userPhoto) {
          <img
            [src]="this.sanitizer.bypassSecurityTrustResourceUrl('data:image/png;base64,' + this.user.userPhoto)"
            style="border-radius: 25px; width: 35px; height: 35px; object-fit: cover" />
        }
        @if (!this.user?.userPhoto) {
          <img src="../../../../assets/images/nouser.png" alt="" />
        }

        <span class="toolbar-user-options">
          <ul class="text-start">
            <li>
              <dx-button
                text="{{ 'TOOLBAR_MY_SETTINGS' | translate }}"
                (onClick)="this.goToProfilePage()"
                class="btn-transparent w-100 rounded-0 text-start px-4"></dx-button>
            </li>
            <!--<li *ngIf="this.authService.checkPermission(this.permissions.admin_servicecatalog_view)">
        <dx-button text="{{'TOOLBAR_CATALOG_MANAGEMENT' | translate}}" (onClick)="this.goToAdminServiceCatalogPage()" class="btn-transparent w-100 rounded-0 text-start px-4"></dx-button>
      </li>
      <li *ngIf="this.authService.checkPermission(this.permissions.admin_problems_view)">
        <dx-button text="{{'TOOLBAR_PROBLEM_MANAGEMENT' | translate}}" (onClick)="this.goToProblemsPage()" class="btn-transparent w-100 rounded-0 text-start px-4"></dx-button>
      </li>-->
            @if (this.authService.checkPermission(this.permissions.admin_adminPanel_view)) {
              <li>
                <dx-button
                  text="{{ 'ADMIN_PANEL' | translate }}"
                  (onClick)="this.goToAdminPanel()"
                  class="btn-transparent w-100 rounded-0 text-start px-4"></dx-button>
              </li>
            }
            <li>
              @if (this.authService.isLoggedIn()) {
                <dx-button
                  text="{{ 'TOOLBAR_LOGOUT' | translate }}"
                  (onClick)="this.logout()"
                  icon="mdi mdi-logout"
                  class="btn-transparent w-100 rounded-0 text-start px-4"></dx-button>
              }
            </li>
          </ul>
        </span>
      </a>
    </div>
  </div>
</div>

<ng-template #loading>
  <span>
    <img src="../../../../assets/images/icon_wait.gif" class="notifications-load" />
  </span>
</ng-template>
